import { useEffect, useState } from 'react';

// @see https://usehooks.com/useWindowSize/
export const useWindowSize = (viewport: number): boolean => {
  const [windowSize, setWindowSize] = useState<boolean>(window.innerWidth < viewport);
  useEffect(() => {
    function handleResize() {
      setWindowSize(window.innerWidth < viewport);
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, [viewport]);
  return windowSize;
};
